<template>
  <div class="identity-backdrop">
    <div class="identity-card">
      <div class="identity-card__brand">
        <div class="auto-auction-logo" aria-label="AutoAuction.com">
          <span class="auto-auction-logo__auto">Auto</span><span class="auto-auction-logo__auction">Auction</span><span class="auto-auction-logo__top-level-domain">.com</span>
        </div>
      </div>
      <div class="identity-card__actions">
        <h1 class="identity-card__title">{{ t('authentication.linking.welcomeTitle', { name: firstName }) }}</h1>
        <p class="identity-card__lede">{{ t('authentication.linking.welcomeLede') }}</p>
        <button class="button button--primary welcome__primary" type="button" @click="goToApp">
          {{ t('authentication.linking.welcomeButton') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import '../shared/identity-card.css';
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { sessionStore } from '@hds/identity-client-sdk';

defineOptions({ name: 'WelcomePage' });

// The create-account landing (account-linking design, UI ruling 4): the
// account exists, access does not — access is granted by a dealership or
// auction house invitation. The desktop app has one front door, its root, so
// that is where the one button lands; the app's own guard decides what a
// person with no access sees there.

const router = useRouter();
const { t } = useI18n();
const session = sessionStore();

const firstName = computed(() => {
  const name = session.user?.name || '';
  return name.split(' ')[0] || name;
});

function goToApp() {
  router.replace('/');
}
</script>

<style scoped>
/* The shared card skin lives in ../shared/identity-card.css. */
</style>
